"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchData = searchData;
exports.getReport = getReport;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

var _ApiUtils = require("@/utils/ApiUtils");

var _DateUtil = require("@/utils/DateUtil");

var _axios = _interopRequireDefault(require("axios"));

var ASIGNACIONES_URL = process.env.VUE_APP_CONSULTAS_URL + '/asignacion';
var REPORTE_ASIGNACIONES_URL = process.env.VUE_APP_CONSULTAS_URL + '/reporte/asignacion';

function searchData(query) {
  var promise = _axios.default.get("".concat(ASIGNACIONES_URL).concat(query)).catch(function (error) {
    return (0, _ApiUtils.mapError)(error);
  }); // using .then, create a new promise which extracts the data


  return promise.then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
}

function getReport(filtro) {
  var fuero = filtro.fuero,
      zona = filtro.zona,
      profesion = filtro.profesion,
      agrupacion = filtro.agrupacion,
      fechaDesde = filtro.fechaDesde,
      fechaHasta = filtro.fechaHasta;
  var post = {
    query: "fuero:".concat(fuero.id, ",zona:").concat(zona.id, ",prof:").concat(profesion.id, ",date>").concat(fechaDesde.replaceAll('-', ''), ",date<").concat(fechaHasta.replaceAll('-', '')),
    filtros: "fuero:".concat(fuero.descripcion, ",zona:").concat(zona.descripcion, ",prof:").concat(profesion.descripcion, ",agrup:").concat(agrupacion.descripcion, ",desde:").concat(fechaDesde.replaceAll('-', ''), ",hasta:").concat(fechaHasta.replaceAll('-', ''))
  };

  var promise = _axios.default.post("".concat(REPORTE_ASIGNACIONES_URL, "?sort=creacionFecha,desc"), post, {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/pdf'
    }
  }).catch(function (error) {
    return (0, _ApiUtils.mapError)(error);
  });

  return promise.then(function (response) {
    var url = window.URL.createObjectURL(new Blob([response === null || response === void 0 ? void 0 : response.data]));
    var link = document.createElement('a');
    link.href = url;
    var hoy = new Date();
    link.setAttribute('download', "informe.asignaciones.".concat((0, _DateUtil.getDateStingFromDate)(hoy), ".").concat(hoy.getHours(), "-").concat(hoy.getMinutes(), ".pdf"));
    document.body.appendChild(link);
    link.click();
  });
}